(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smx-purchase-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smx-purchase-summary')) {
    customElements.define(
      'smx-purchase-summary',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('[id^="shopify-section-"]');
          this.productInfo = section?.querySelector('[id^="ProductInfo-"]');
          if (!this.productInfo) return;

          this.schedule = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.updateLabel();
            });
          };

          this.observer = new MutationObserver(this.schedule);
          this.observer.observe(this.productInfo, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['class', 'checked', 'disabled', 'aria-disabled'],
          });
          this.productInfo.addEventListener('change', this.schedule);
          this.productInfo.addEventListener('click', this.schedule);
          this.schedule();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.productInfo?.removeEventListener('change', this.schedule);
          this.productInfo?.removeEventListener('click', this.schedule);
          cancelAnimationFrame(this.frame);
          this.frame = null;
        }

        updateLabel() {
          if (!this.isConnected) return;

          const button = this.productInfo.querySelector('.product-form__submit');
          const label = button?.querySelector(':scope > span');
          if (!label || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

          const cards = Array.from(
            this.productInfo.querySelectorAll('.moonbundle-subscription-radio-option')
          );
          const selected = cards.find((card) => card.querySelector('input[type="radio"]:checked'));
          const title = selected?.querySelector('.moonbundle-subscription-option-title');
          const splitPrice = title?.querySelector('.mb-price-split-value')?.textContent.trim();
          const prices = title?.textContent.match(/\$[0-9][0-9.,]*/g);
          const price = splitPrice || prices?.[prices.length - 1];
          const text = price
            ? `${this.dataset.label} · ${price} →`
            : `${this.dataset.label} →`;

          if (label.textContent !== text) label.textContent = text;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
